import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }
  }
};

export const ServicesSection = () => {
  const services = [
    { id: 'energioptimering', title: 'Energioptimering', href: '/ydelser/energioptimering' },
    { id: 'lysstyring', title: 'Intelligent lysstyring', href: '/ydelser/lysstyring' },
    { id: 'service', title: 'Service & vedligehold', href: '/ydelser/service' },
  ];

  return (
    <section 
      data-testid="services-section" 
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-8 md:px-16 lg:px-24">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
          className="mb-12"
        >
          <p className="text-[#A6B8A2] text-sm mb-4">
            Vores løsninger
          </p>
          <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-4xl lg:text-5xl font-medium text-[#1E2A24] mb-6">
            Integrerede energi- og belysningsløsninger
          </h2>
          <p className="text-[#1E2A24]/60 max-w-2xl">
            Vi analyserer eksisterende installationer, implementerer energioptimering og leverer driftssikre belysningsløsninger til erhvervsbygninger. Hele processen håndteres af ét samlet team – fra analyse og projektering til installation og efterfølgende service.
          </p>
        </motion.div>

        {/* Services as pill links like Neonsign */}
        <motion.div 
          className="flex flex-wrap gap-3"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={containerVariants}
        >
          {services.map((service) => (
            <motion.div
              key={service.id}
              variants={itemVariants}
            >
              <Link 
                to={service.href}
                className="inline-flex items-center gap-2 px-6 py-3 border border-[#1E2A24]/20 text-[#1E2A24] hover:border-[#0E3D24] hover:text-[#0E3D24] transition-colors duration-300 group"
                data-testid={`service-link-${service.id}`}
              >
                <span>{service.title}</span>
                <ArrowRight size={14} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
              </Link>
            </motion.div>
          ))}
        </motion.div>

        {/* View all link */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-10"
        >
          <Link 
            to="/kontakt"
            className="inline-flex items-center gap-2 text-[#1E2A24]/60 hover:text-[#0E3D24] transition-colors group"
          >
            <span className="text-sm">Kontakt os</span>
            <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
